export const SHOW_INTRO = 'SHOW_INTRO';
